export default __webpack_public_path__ + "static/Agile-LightItalic-d03948ad702d0bba2cdea2931b084eab.ttf";